import {errorService} from "@mytour/platform";
import type {Worker} from "@mytour/shared";
import axios from "axios";
import {toast} from "react-toastify";
import {Button} from "reactstrap";
import {useActivateWorker, useDeactivateWorker} from "../../../../query/teamWorkerQueries.js";

interface ToggleWorkerActiveActionProps {
  worker: Worker;
}

export function ToggleWorkerActiveAction({worker}: ToggleWorkerActiveActionProps) {
  const {activateWorker, isActivatingWorker} = useActivateWorker();
  const {deactivateWorker, isDeactivatingWorker} = useDeactivateWorker();

  return (
    <Button
      size="sm"
      color={worker.isActive ? "warning" : "success"}
      outline
      onClick={handleToggle}
      disabled={isActivatingWorker || isDeactivatingWorker}
    >
      {worker.isActive ? "Désactiver" : "Activer"}
    </Button>
  );

  async function handleToggle() {
    try {
      if (worker.isActive) {
        await deactivateWorker(worker.id);
      } else {
        await activateWorker(worker.id);
      }
    } catch (error) {
      const fallback = worker.isActive
        ? "Impossible de désactiver cet intervenant"
        : "Impossible d'activer cet intervenant";
      /**
       * Seul un refus 400 porte un message pensé pour l'utilisateur (adresse non
       * géocodable/imprécise) ; sur toute autre erreur, `error.message` d'Axios est
       * un texte technique anglais — même garde que getSubmissionErrorMessage (#799).
       */
      const isKnownBadRequest = axios.isAxiosError(error) && error.response?.status === 400;
      toast.error(isKnownBadRequest ? errorService.getMessage(error, fallback) : fallback);
    }
  }
}
